<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.paychannel_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/pay/paychannel';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 6,
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '支付渠道',
            prop: 'payPlatform',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payChannel',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            search: true,
            dataType: 'number',
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入支付渠道',
                trigger: 'change',
              },
            ],
          },

          {
            label: '接入方式',
            prop: 'payMethod',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payMethod',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入接入方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付场景',
            prop: 'payScene',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payScene',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 100,
            rules: [
              {
                required: false,
                message: '请输入支付场景',
                trigger: 'change',
              },
            ],
          },
          {
            label: '商户号',
            prop: 'payMchId',
            search: true,
            rules: [
              {
                required: true,
                message: '请输入商户号',
                trigger: 'change',
              },
            ],
          },
          {
            label: 'APPID',
            prop: 'payAppid',
            rules: [
              {
                required: false,
                message: '请输入APPID/柜台号',
                trigger: 'change',
              },
            ],
          },
          {
            label: 'APP密钥',
            prop: 'appSecret',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入APP密钥',
                trigger: 'change',
              },
            ],
          },
          {
            label: '子商户号',
            prop: 'subMchId',
            rules: [
              {
                required: false,
                message: '请输入子商户号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '子APPID',
            prop: 'subAppid',
            rules: [
              {
                required: false,
                message: '请输入子APPID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '子APP密钥',
            prop: 'subAppSecret',
            hide: true,
            labelWidth: 100,
            rules: [
              {
                required: false,
                message: '请输入子APP密钥',
                trigger: 'change',
              },
            ],
          },
          {
            label: '加密方式',
            prop: 'signType',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入加密方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '公钥',
            prop: 'publicKey',
            span: 24,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入公钥',
                trigger: 'change',
              },
            ],
          },
          {
            label: '私钥',
            prop: 'privateKey',
            span: 24,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入私钥',
                trigger: 'change',
              },
            ],
          },
          {
            label: '授权token',
            prop: 'appAuthToken',
            span: 24,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入授权token',
                trigger: 'change',
              },
            ],
          },
          {
            label: '证书路径',
            prop: 'certPath',
            span: 24,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入证书路径',
                trigger: 'change',
              },
            ],
          },
          {
            label: '字符编码格式',
            prop: 'charset',
            labelWidth: 110,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入字符编码格式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '数据格式',
            prop: 'dataType',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入数据格式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '服务器网关',
            prop: 'serviceUrl',
            labelWidth: 100,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入服务器网关',
                trigger: 'change',
              },
            ],
          },
          {
            label: '服务器回调',
            prop: 'notifyUrl',
            labelWidth: 100,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入服务器回调',
                trigger: 'change',
              },
            ],
          },
          {
            label: '页面回调',
            prop: 'pagejumpUrl',
            span: 24,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入页面回调',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付开关',
            prop: 'payChannelStatus',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=switch',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            search: true,
            width: 80,
            rules: [
              {
                required: true,
                message: '请输入支付开关状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '对账开关',
            prop: 'isBalance',

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=switch',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 80,
            rules: [
              {
                required: true,
                message: '请输入对账开关状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注说明',
            prop: 'extraInfo',
            span: 24,
            rules: [
              {
                required: false,
                message: '请输入备注说明',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.paychannel_add, false),
        viewBtn: this.vaildData(this.permission.paychannel_view, false),
        delBtn: this.vaildData(this.permission.paychannel_delete, false),
        editBtn: this.vaildData(this.permission.paychannel_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
